import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

function Reveal({ children, className = '', as: Tag = 'div', delay = 0, ...rest }) {
    const [ref, visible] = useScrollReveal();

    return (
        <Tag
            ref={ref}
            className={`reveal ${visible ? 'reveal-visible' : ''} ${className}`.trim()}
            style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
            {...rest}
        >
            {children}
        </Tag>
    );
}

export default Reveal;
